import { Consume } from "../../../Context/Consumer";
import React, { Component } from "react";
import {
  PlayerListContext,
  TransContext,
  TeamDataContext,
  ConstraintsContext,
} from "../../../Context";
import {
  getTrans,
  customTracking,
  setDropDownHeight,
  getPageName,
} from "../../../common";
import { Scrollbars } from "react-custom-scrollbars";
import config from "../../../common/config";
import OutsideNotifier from "../../../components/OutsideNotifier";

class WebPriceFilter extends Component {
  constructor(props) {
    super(props);
    this.state = {
      openPriceByWeb: false,
    };
    this.priceFilter = this.props.ConstraintsData.data.priceFilter;
  }

  onPriceFilterOpen = (value) => {
    if (value != undefined) {
      this.setState({
        openPriceByWeb: false,
      });
    } else {
      this.setState({
        openPriceByWeb: !this.state.openPriceByWeb,
      });
    }
  };

  // onPriceSelect = (obj) => {
  //   let skillId = obj.map;
  //   let budget = this.props.TeamData.data.budget;
  //   if (skillId == 0) {
  //     if (
  //       this.props.PlayerListData.playerListFilters.skillId.indexOf(skillId) >
  //       -1
  //     ) {
  //       this.props.PlayerListData.playerListFilters.skillId = [];
  //     } else {
  //       let skillName = config.positionMap[skillId]
  //         ? config.positionMap[skillId].skill
  //         : "All";
  //       this.props.PlayerListData.playerListFilters.skillId = [0];
  //     }
  //   } else {
  //     if (this.props.PlayerListData.playerListFilters.skillId.indexOf(0) > -1) {
  //       let index =
  //         this.props.PlayerListData.playerListFilters.skillId.indexOf(0);
  //       this.props.PlayerListData.playerListFilters.skillId.splice(index, 1);
  //     }
  //     if (
  //       this.props.PlayerListData.playerListFilters.skillId.indexOf(skillId) >
  //       -1
  //     ) {
  //       let index =
  //         this.props.PlayerListData.playerListFilters.skillId.indexOf(skillId);
  //       this.props.PlayerListData.playerListFilters.skillId.splice(index, 1);
  //     } else {
  //       let skillName = config.positionMap[skillId]
  //         ? config.positionMap[skillId].skill
  //         : "All";
  //       this.props.PlayerListData.playerListFilters.skillId.splice(0, 1);
  //       this.props.PlayerListData.playerListFilters.skillId.push(skillId);
  //     }
  //   }

  //   this.props.PlayerListData.setPlayerFilters(
  //     this.props.PlayerListData.playerListFilters,
  //     budget
  //   );
  //   this.onSkillFilterOpen(false);
  // };

  setPriceFilter = (priceObj) => {
    let price = priceObj.label;
    this.props.PlayerListData.playerListFilters.priceFilterSelected = price;
    let budget = this.props.TeamData.data.budget;
    this.props.PlayerListData.playerListFilters.priceFilterObj = [
      { ...priceObj, selected: true },
    ];
    this.props.PlayerListData.setPlayerFilters(
      this.props.PlayerListData.playerListFilters,
      budget
    );
    // customTracking('Select Price Filter - ' + (config.priceTrans[priceObj.id] ? config.priceTrans[priceObj.id] : priceObj.label), getPageName());
    this.setState({
      openPriceByWeb: false,
    });
  };

  // onPriceSortOpen = (value) => {
  //   if (value != undefined) {
  //     this.setState({
  //       openPriceByWeb: false,
  //     });
  //   } else {
  //     this.setState({
  //       openPriceByWeb: !this.state.openSortByWeb,
  //     });
  //   }
  // };

  // resetPriceFilter = (e) => {
  //   e.stopPropagation();

  //   this.props.PlayerListData.playerListFilters.priceFilterSelected = "";
  //   let budget = this.props.TeamData.data.budget;
  //   this.props.PlayerListData.setPlayerFilters(
  //     this.props.PlayerListData.playerListFilters,
  //     budget
  //   );
  //   this.setState({
  //     openPriceByWeb: false,
  //   });
  // };

  render() {
    const { openPriceByWeb } = this.state;
    const { priceFilter, onPriceFilterOpen, setPriceFilter } = this;
    let { PlayerListData, TransData } = this.props;
    let trans = TransData.data;
    let priceSelected = PlayerListData.playerListFilters.priceFilterSelected;
    let handler = {
      handler: () => {
        onPriceFilterOpen(false);
      },
    };

    let { priceFilterSelected, priceFilterObj } =
      PlayerListData.playerListFilters;
    return (
      <div className="si-form__control">
        <OutsideNotifier {...handler}>
          <div className="si-lbl">
            <span>{getTrans(trans,"Price","Price")}</span>
          </div>
          <div
            className={"si-drpDwn " + (openPriceByWeb ? "si-active" : "")}
            onClick={() => onPriceFilterOpen()}
          >
            <div
              className={`si-drpDwn__value ${
                priceFilterObj[0]?.selected ? "si-picked" : ""
              }`}
            >
              <span>
                {getTrans(trans,priceFilterSelected) ? getTrans(trans,priceFilterSelected) : getTrans(trans,"Unlimited","Unlimited")}
              </span>
              <select
                onChange={(e) => {
                  const price = priceFilter.filter(
                    (a) => a.label === e.target.value
                  );
                  setPriceFilter(...price);
                }}
              >
                {priceFilter.map((price) => {
                  return (
                    <option
                      key={price.id}
                      // onClick={() => {
                      // setPriceFilter(price);
                      // }}
                      className={
                        priceFilterObj[0]?.id === price.id ? "si-active" : ""
                      }
                    >
                      {getTrans(trans, price.labelTrans, price.label)}
                    </option>
                  );
                })}
              </select>
            </div>
            <div className="si-drpDwn__list">
                <Scrollbars className="si-scroll_js">
              <ul>
                  {priceFilter.map((price) => {
                    return (
                      <li
                        key={price.id}
                        onClick={() => {
                          setPriceFilter(price);
                        }}
                        className={
                          priceFilterObj[0]?.id === price.id ? "si-active" : ""
                        }
                      >
                        {getTrans(trans, price.labelTrans, price.label)}
                      </li>
                    );
                  })}
              </ul>
                </Scrollbars>
            </div>
          </div>
        </OutsideNotifier>
      </div>
    );

    return (
      <div
        className={
          this.state.openPriceByWeb
            ? "si-dropdown__wrap si-dropdown--white si-show"
            : "si-dropdown__wrap si-dropdown--white"
        }
      >
        <div
          className={
            PlayerListData.playerListFilters.priceFilterSelected != ""
              ? "si-dropdown__btn si-curved si-selected"
              : "si-dropdown__btn si-curved"
          }
          onClick={() => this.onPriceSortOpen()}
        >
          <div className="si-dropdown__txt">
            {" "}
            {priceSelected == ""
              ? getTrans(trans, "Price", "Price")
              : priceSelected == "Affordable" || priceSelected == "Unlimited"
              ? getTrans(trans, priceSelected, priceSelected)
              : getTrans(trans, "Upto", "Up to") + " " + priceSelected}
          </div>
          <div className="si-dropdown__action">
            {PlayerListData.playerListFilters.priceFilterSelected != "" ? (
              <div
                onClick={(e) => {
                  this.resetPriceFilter(e);
                }}
                className="si-icon euro-cross-round"
              ></div>
            ) : null}
            <div className="si-dropdown__close euro-drop-down"></div>
          </div>
        </div>
        {this.state.openPriceByWeb ? (
          <OutsideNotifier handler={() => this.onPriceSortOpen(false)}>
            <ul
              className="si-dropdown__menu"
              style={setDropDownHeight(
                "WebPriceFilter",
                45,
                this.priceFilter.length
              )}
              id={"WebPriceFilter"}
            >
              <Scrollbars className="si-scroll_js">
                {this.priceFilter.map((priceObj) => {
                  return (
                    <li
                      className={
                        PlayerListData.playerListFilters.priceFilterSelected ==
                        priceObj.label
                          ? "si-selected--tertiary"
                          : ""
                      }
                      onClick={() => {
                        this.setPriceFilter(priceObj);
                      }}
                      key={priceObj.label}
                    >
                      <a className="si-dropdown__item">
                        {priceObj.label == "Affordable" ||
                        priceObj.label == "Unlimited"
                          ? getTrans(trans, priceObj.label, priceObj.label)
                          : getTrans(trans, "Upto", "Up to") +
                            " " +
                            priceObj.label}
                      </a>
                    </li>
                  );
                })}
              </Scrollbars>
            </ul>
          </OutsideNotifier>
        ) : null}
      </div>
    );
  }
}

export default Consume(WebPriceFilter, [
  PlayerListContext,
  TransContext,
  TeamDataContext,
  ConstraintsContext,
]);
